module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ourPartners":"Наши партнёры"},"uk":{"ourPartners":"Наші партнери"}}')
  delete Component.options._Ctor
}
